import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeople: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people, user, person, avatar"><path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><path d="M12.0004 12.5C7.8271 12.5 4.77345 15.2936 3.9402 19.0013C3.69057 20.112 4.60014 21 5.59882 21H18.402C19.4007 21 20.3102 20.112 20.0606 19.0013C19.2274 15.2936 16.1737 12.5 12.0004 12.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPeople;
